import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import "./Home.css";
import { PostData } from "../../services/PostData";
import "../../styles/react-confirm-alert.css";
import NavSup from "../NavSup/NavSup";
import NavInf from "../NavInf/NavInf";
import AddSystem from "../AddSystem/AddSystem";
import RoomsList from "../RoomsList/RoomsList";
import CreateRoomMenuComponent from "../CreateRoomMenuComponent/CreateRoomMenuComponent";

import createRoomIcon from "../../images/subasta-create-room-icon.png";
//import searchRoomIcon from "../../images/subasta-search-room-icon.png";
import KeyIcon from "../../images/subasta-key-icon.png";
import ShopingCartUserCard from "../../images/shoping-cart-user-card.png";
import Trophies from "../Trophies/Tropies";

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      userFeed: "",
      redirectToReferrer: false,
      name: "",
      userId: "",
      viewCreateRoomsMenu: false,
      userRanking: "",
      userRankingList: {},
      keys: null,
      showRanking: false,
      showMyRanking: true,
      showTrophies: false,
    };

    //this.getUserFeed = this.getUserFeed.bind(this);
    this.feedUpdate = this.feedUpdate.bind(this);
    this.onChange = this.onChange.bind(this);
    this.deleteFeed = this.deleteFeed.bind(this);
    this.deleteFeedAction = this.deleteFeedAction.bind(this);
    this.logout = this.logout.bind(this);
    this.openCreateRoomMenuComponent =
      this.openCreateRoomMenuComponent.bind(this);
    this.openRanking = this.openRanking.bind(this);
    this.closeRanking = this.closeRanking.bind(this);
    this.getUserRanking = this.getUserRanking.bind(this);
  }

  componentWillMount() {
    if (localStorage.getItem("userData")) {
      let data = JSON.parse(localStorage.getItem("userData"));
      let isAdmin = true;
      if (
        data.userData.mail === "sierra.emilio@gmail.com" ||
        data.userData.mail === "camilovelaindustrial@gmail.com" ||
        data.userData.mail === "fazco20@yahoo.com"
      ) {
        isAdmin = true;
      }
      this.setState({
        name: data.userData.name,
        userId: data.userData.id,
        changePass: data.userData.change_pass,
        keys: data.userData.credits,
        email: data.userData.mail,
        isAdmin: isAdmin,
      });
      //let data = localStorage.getItem("userData");
      //console.log(data);
    } else {
      //this.setState({ redirectToReferrer: true, name: this.data.name });
      window.history.pushState("Login", "subasta", "/");
      window.history.go();
    }
  }

  feedUpdate(e) {
    e.preventDefault();
    let data = JSON.parse(localStorage.getItem("userData"));
    let postData = {
      user_id: data.userData.user_id,
      feed: this.state.userFeed,
    };
    if (this.state.userFeed) {
      PostData("feedUpdate", postData).then((result) => {
        let responseJson = result;
        this.setState({ data: responseJson.feedData });
      });
    }
  }

  deleteFeed(e) {}

  deleteFeedAction(e) {
    let updateIndex = e.target.getAttribute("value");

    let feed_id = document.getElementById("del").getAttribute("data");

    let data = JSON.parse(localStorage.getItem("userData"));

    let postData = { user_id: data.userData.user_id, feed_id: feed_id };
    if (postData) {
      PostData("feedDelete", postData).then((result) => {
        this.state.data.splice(updateIndex, 1);
        this.setState({ data: this.state.data });

        if (result.success) {
          alert(result.success);
        } else alert(result.error);
      });
    }
  }

  editFeed(e) {
    alert("j");
  }

  onChange(e) {
    this.setState({ userFeed: e.target.value });
  }
  logout() {
    localStorage.setItem("userData", "");
    localStorage.clear();
    this.setState({ redirectToReferrer: true });
  }

  openCreateRoomMenuComponent(e) {
    var body = document.getElementsByClassName("subasta-dashboard-container");
    body[0].style.overflow = "hidden";
    this.setState({ viewCreateRoomsMenu: true });
  }

  getUserRanking() {
    let data = JSON.parse(localStorage.getItem("userData"));
    //console.log("USUARIO ID: ", data.userData.id);
    let postData = {
      user_id: data.userData.id,
      name: data.userData.name,
    };
    PostData("getUserRanking", postData).then((result) => {
      let responseJson = result;
      //console.log(responseJson);

      let rankingList = responseJson.rankingList;

      //console.log("Ranking List =", rankingList);

      function compare(a, b) {
        const winningQuantityA = parseInt(a.friend_winning_matchs);
        const winningQuantityB = parseInt(b.friend_winning_matchs);
        let comparison = 0;
        if (winningQuantityA > winningQuantityB) {
          comparison = -1;
        } else if (winningQuantityA < winningQuantityB) {
          comparison = 1;
        }
        return comparison;
      }
      //this.setState({userRanking : rankingData[0]}, ()=>console.log(this.state.userRanking));

      rankingList.sort(compare);

      const simplefiedRankingList = rankingList
        .reduce((acc, current) => {
          const x = acc.find((item) => item.friend_id === current.friend_id);
          if (!x) {
            return acc.concat([current]);
          } else {
            return acc;
          }
        }, [])
        .sort(compare);

      //console.log(simplefiedRankingList);

      this.setState({ userRankingList: { ...simplefiedRankingList } }, () => {
        //console.log("Ranking List Ordered =", this.state.userRankingList);
      });

      // console.log(
      //   "mi ranking es: ",
      //   rankingList.findIndex((obj) => obj.friend_id === this.state.userId) +
      //     1
      // ); // +1 to get the rankign list from 1 instead 0
      this.setState(
        {
          userRanking:
            simplefiedRankingList.findIndex(
              (obj) => obj.friend_id === this.state.userId,
            ) + 1,
        },
        () => {}, //console.log("mi ranking es: ", this.state.userRanking)
      );
      let userRanking = this.state.userRanking;
      localStorage.setItem("userRanking", userRanking);
    });
  }

  openRanking() {
    this.setState({ showRanking: true });
  }

  closeRanking() {
    this.setState({ showRanking: false });
    window.location.href = "/";
  }

  render() {
    //console.log(this.state.data);
    if (this.state.changePass === "1") {
      return <Redirect to={"/recovery"} />;
    }
    let viewCreateRoomsMenu = this.state.viewCreateRoomsMenu;
    if (this.state.redirectToReferrer) {
      return <Redirect to={"/"} />;
    }

    let userRanking = localStorage.getItem("userRanking");

    let displayRankingList;
    if (this.state.showRanking) {
      let rankingList = { ...this.state.userRankingList };
      //console.log("el ranking es: ", rankingList);
      let rankingListHtml = [];
      let position = 1;
      for (const prop in rankingList) {
        //console.log(`rankingList.${prop} = ${rankingList[prop].friend_name}`);
        rankingListHtml.push(
          <React.Fragment key={position}>
            <div className="rankingRow" key={position}>
              <div className="positionNumber">{position}. </div>
              <div className="nameText"> {rankingList[prop].friend_name} </div>
              <div className="winningMatchNumber">
                {rankingList[prop].friend_winning_matchs}
              </div>
            </div>
          </React.Fragment>,
        );
        position++;
      }

      displayRankingList = (
        <div className="rankingListContainer">
          <div className="ranking-closeBtn">
            <div
              className="closeBtn"
              onClick={() => {
                this.closeRanking();
              }}
            >
              X
            </div>
          </div>
          <h1>RANKING</h1>
          <div className="rankingList">
            <div className="ranking-headings">
              <div className="position-title">POS</div>
              <div className="name-title">Nombre</div>
              <div className="winningMatchs-title">Partidos Acertados</div>
            </div>
            <div className="ranking-data">{rankingListHtml}</div>
          </div>
        </div>
      );
    }

    return (
      <React.Fragment>
        <div className="subasta-dashboard-container" key={Date.now()}>
          <NavSup />
          <AddSystem />
          <h1 className="home-title">Mi Perfil</h1>
          <div className="subasta-user-section">
            <div className="subasta-create-room-btn-container desktop">
              <div className="create-room-btn">
                <img
                  src={createRoomIcon}
                  alt=""
                  onClick={this.openCreateRoomMenuComponent}
                />
              </div>
              <h4 onClick={this.openCreateRoomMenuComponent}>CREAR SALA</h4>
            </div>
            <div className="subasta-user-card-container">
              <div className="subasta-user-card-first-row">
                <div className="subasta-user-card-text">{this.state.name}</div>
              </div>
              <div className="subasta-user-card-second-row">
                <div
                  className="subasta-user-card-col"
                  onClick={() => {
                    this.setState({ showTrophies: true });
                  }}
                >
                  <div className="subasta-user-card-text">Mis Trofeos:</div>
                  <div className="subasta-trophy-container">
                    <svg
                      fill="#979797"
                      height="50px"
                      width="50px"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 511.999 511.999"
                      stroke="#979797"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        <g>
                          <g>
                            <path d="M355.485,452.127h-50.128l19.365-166.166c0.252-2.164-0.433-4.332-1.881-5.96s-3.524-2.558-5.702-2.558h-3.67 l11.997-66.482c28.784-21.323,47.48-55.526,47.48-94.018c0-12.711-2.046-24.952-5.814-36.419 c-0.018-0.071-0.031-0.144-0.052-0.215c-0.074-0.252-0.161-0.499-0.259-0.738C351.196,33.359,307.421,0,256,0 c-0.001,0-0.002,0-0.003,0h-0.001h-0.001c-51.402,0.002-95.164,33.339-110.802,79.527c-0.106,0.253-0.201,0.514-0.28,0.784 c-0.028,0.097-0.046,0.193-0.07,0.29c-3.752,11.446-5.789,23.66-5.789,36.343c0,37.868,18.099,71.585,46.094,92.971 c0.241,0.23,0.493,0.451,0.768,0.652c0.149,0.108,0.308,0.187,0.461,0.283l13.94,66.593h-5.458c-2.178,0-4.254,0.931-5.702,2.558 c-1.448,1.628-2.132,3.796-1.881,5.96l19.365,166.166h-55.32c-4.216,0-7.634,3.418-7.634,7.634v44.605 c0,4.216,3.418,7.634,7.634,7.634h204.161c4.216,0,7.634-3.418,7.634-7.634V459.76 C363.119,455.545,359.701,452.127,355.485,452.127z M357.677,116.944c0,30.856-13.819,58.542-35.589,77.205l-30.044-41.153 l15.321-47.152l47.2-13.892C356.595,99.951,357.677,108.323,357.677,116.944z M263.631,15.554 c38.779,2.891,71.57,27.628,86.069,61.914l-46.903,13.804l-39.166-28.455V15.554z M255.997,76.143l36.377,26.43l-13.895,42.764 h-44.964l-13.895-42.764L255.997,76.143z M248.363,15.554v47.264l-39.166,28.455l-46.898-13.802 C176.797,43.185,209.586,18.448,248.363,15.554z M189.019,193.374c-21.254-18.65-34.696-45.998-34.696-76.429 c0-8.62,1.082-16.992,3.112-24.99l47.194,13.89l14.874,45.776L189.019,193.374z M231.847,160.605h46.848l31.092,42.587 c-15.612,9.771-34.049,15.43-53.786,15.43c-20.159,0-38.966-5.897-54.787-16.057L231.847,160.605z M308.02,221.66l-10.066,55.783 h-82.037l-11.646-55.638c15.606,7.73,33.167,12.084,51.73,12.084C274.678,233.889,292.343,229.481,308.02,221.66z M203.436,292.712h6.279h94.618h4.23l-18.578,159.416h-43.587l-14.635-129.027c-0.474-4.19-4.262-7.204-8.445-6.725 c-4.19,0.475-7.2,4.257-6.725,8.445l14.439,127.307h-9.019L203.436,292.712z M347.851,496.732H158.957v-29.337h56.26h24.344 c0.004,0,0.007,0,0.01,0s0.006,0,0.009,0h57.201h51.069V496.732z"></path>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </div>

                  {this.state.showTrophies && (
                    <div className="trophies-home-container">
                      <Trophies key={Date.now()}></Trophies>
                    </div>
                  )}
                </div>
              </div>
              <div className="subasta-user-card-third-row">
                <div
                  className="subasta-user-card-col"
                  onClick={() => {
                    this.getUserRanking();
                    this.openRanking();
                  }}
                >
                  <div className="subasta-user-card-text">Mi Ranking:</div>
                  <div className="subasta-ranking-container">
                    <div className="subasta-user-card-ranking-value">
                      {userRanking}
                    </div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 576 512"
                    >
                      <path d="M279.6 160.4C282.4 160.1 285.2 160 288 160C341 160 384 202.1 384 256C384 309 341 352 288 352C234.1 352 192 309 192 256C192 253.2 192.1 250.4 192.4 247.6C201.7 252.1 212.5 256 224 256C259.3 256 288 227.3 288 192C288 180.5 284.1 169.7 279.6 160.4zM480.6 112.6C527.4 156 558.7 207.1 573.5 243.7C576.8 251.6 576.8 260.4 573.5 268.3C558.7 304 527.4 355.1 480.6 399.4C433.5 443.2 368.8 480 288 480C207.2 480 142.5 443.2 95.42 399.4C48.62 355.1 17.34 304 2.461 268.3C-.8205 260.4-.8205 251.6 2.461 243.7C17.34 207.1 48.62 156 95.42 112.6C142.5 68.84 207.2 32 288 32C368.8 32 433.5 68.84 480.6 112.6V112.6zM288 112C208.5 112 144 176.5 144 256C144 335.5 208.5 400 288 400C367.5 400 432 335.5 432 256C432 176.5 367.5 112 288 112z" />
                    </svg>
                  </div>

                  {this.state.showRanking && <div>{displayRankingList}</div>}
                </div>
              </div>
            </div>
          </div>
          {viewCreateRoomsMenu && (
            <div className="subasta-createRoomsMenu-container">
              <CreateRoomMenuComponent isAdmin={this.state.isAdmin} />
            </div>
          )}
          <RoomsList />
          <NavInf isAdmin={this.state.isAdmin} />
        </div>
      </React.Fragment>
    );
  }
}

export default Home;
